import React, { useContext, useEffect } from 'react';
import { useBasePath } from '../../customHooks/useBasePath';
import NavbarLoginBody from './NavbarLoginBody';
import NavBody from './NavBody';
import { t } from 'i18next';
import NavbarReturnBody from './NavbarReturnBody';
import NavAccessBody from './NavAccessBody';
import NavSettingsBody from './NavSettingsBody';
import NavReportsBody from './NavReportsBody';
import { useParams } from 'react-router-dom';
import InstanceContext from '../../context/InstanceContext/InstanceContext';
import NavScanAccess from './NavScanAccess';

const NavbarBlue = () => {

  const { setIsReadyForInstall } = useContext(InstanceContext)

  const noHaveParams = Object.keys(useParams()).length === 0;

  const path = useBasePath();

  const navOptions = {
    '/login': {
      body: <NavbarLoginBody />,
      color: 'var(--black)',
    },
    '/loginCC': {
      body: <NavbarLoginBody />,
      color: 'var(--black)',
    },
    '/recoverPassword': {
      body: <NavbarReturnBody title={t('RECOVER_PASSWORD')} returnTo={'/login'} />,
      color: 'var(--black)',
    },
    '/resendMail': {
      body: <NavbarReturnBody title={t('RECOVER_PASSWORD')} returnTo={'/login'} />,
      color: 'var(--black)',
    },
    '/resetPassword': {
      body: <NavbarReturnBody title={t('NEW_PASSWORD')} returnTo={'/login'} />,
      color: 'var(--black)',
    },
    '/passwordHasChange': {
      body: <NavbarReturnBody title={t('NEW_PASSWORD')} returnTo={'/login'} />,
      color: 'var(--black)',
    },
    '/selectAccessOpening': {
      body: <NavBody><h3 className='mt-5 mb-5 white-color'>{t('WELCOME')}</h3></NavBody>,
      color: 'var(--black)',
    },
    '/selectAccessBuildings': {
      body: <NavBody><h3 className='mt-5 mb-5 white-color'>{t('WELCOME')}</h3></NavBody>,
      color: 'var(--black)',
    },
    '/dashboard': {
      body: <NavBody />,
      color: 'var(--black)',
    },
    '/QRScanAccess': {
      body: <NavScanAccess />,
      color: 'var(--gray-700)',
    },
    '/manualAccess': {
      body: <NavbarReturnBody title={t('MANUAL_ENTRY')} returnTo={'/QRScanAccess'} />,
      color: 'var(--black)',
    },
    '/createAccess': {
      body:
        <NavBody
          rowAlignment='align-items-center'
        >
          <NavAccessBody />
        </NavBody>,
      color: 'var(--black)',
    },
    '/settings': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/buildingsMaganagement/create': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/buildingsMaganagement/edit': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/areasMaganagement/create': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/areasMaganagement/edit': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/peopleToVisitMaganagement/create': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/peopleToVisitMaganagement/edit': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/sectorMaganagement/create': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/sectorMaganagement/edit': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/params/preferences/amountOfPeopleToVisitMaganagement': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/equipmentOrToolsMaganagement/create': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/settings/entityManagment/equipmentOrToolsMaganagement/edit': {
      body: <NavBody><NavSettingsBody /></NavBody>,
      color: 'var(--black)',
    },
    '/reports': {
      body:
        <NavBody
          leftColClassName={noHaveParams ? 'col' : 'col col-sm-1'}
          midColClassName={noHaveParams ? 'col-xl-4 col-lg-7 col-sm-9 mt-3 mt-sm-0' : 'col-xl-10 col-sm-10 mt-3 mt-sm-0'}
          rightColClassName={noHaveParams ? 'col' : 'col col-sm-1'}
        >
          <NavReportsBody />
        </NavBody>,
      color: 'var(--black)',
    },
  };

  const currentNav = navOptions[path] ? navOptions[path] : { body: <NavbarLoginBody />, color: 'var(--black)', };

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (event) => {
      // Prevent the mini-infobar from appearing on mobile.
      event.preventDefault();
      // Stash the event so it can be triggered later.
      window.deferredPrompt = event;
      // Remove the 'hidden' class from the install button container.
      setIsReadyForInstall(true);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <nav
      style={{ background: currentNav.color }}
      className='d-flex flex-column p-3 w-100'
    >
      {currentNav.body}
    </nav>
  )
}

export default NavbarBlue